export default "__VITE_ASSET__CW38fXV8__"